<div class="page-container" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="30px">
  <mat-icon class="lock-icon">lock</mat-icon>
  <span i18n="ForbiddenPage.Notes(messageText)@@sorry-you-don-t-have-permission-to-access-this-page" class="message-text">Sorry, you don't have permission to access this page.</span>
  <button mat-raised-button color="primary" routerLink="/" i18n="ForbiddenPage.Button@@go-home">Go home</button>
</div>
